import React, { useContext, useEffect,useRef } from 'react';
import Button from '@material-ui/core/Button';
import SelectAllIcon from '@material-ui/icons/SelectAll';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { store } from '../AddOrEdit';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(1, 0, 0, 2),
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridGap: theme.spacing(1),
  },
  buttons: {
    display: 'inline',
  },
}));

const ListRules = () => {
  const classes = useStyles();
  const {
    state: { category, rules,selectedRules},
    selectCategory,
    selectRules,
    flushRules,
    loadRules,
    setRules
  } = useContext(store);
  const firstRun = useRef(true);
  const rulesCount = selectedRules.length
  
  const handleSelect = (ruleId)=>{
    selectRules([ruleId]);
  }
  const toggleSelectAll = ()=>{
    selectRules(rules.map(rule=>rule._id));
  }

  useEffect(() => {
    loadRules(category._id);
    return () => {
      flushRules();
    };
  }, []);

  useEffect(()=>{
    if(firstRun.current){
      firstRun.current=false;
      return;
    }
    setRules();
  },[rulesCount])

  return (
    <div className={classes.root}>
      <div className={classes.buttons}>
        <Button
          variant="contained"
          color="secondary"
          endIcon={<SelectAllIcon />}
          onClick={toggleSelectAll}
        >
          انتخاب همه
        </Button>
        <Button
          variant="outlined"
          color="secondary"
          style={{ marginRight: 10 }}
          endIcon={<ArrowBackIosIcon />}
          onClick={() => selectCategory(null)}
        >
          بازگشت به لیست نقش‌ها
        </Button>
      </div>
      {rules?.length ? (
        rules?.map((rule) => (
          <FormControlLabel
            control={
              <Checkbox
                checked={selectedRules?.includes(rule._id)?true:false}
                onChange={() => handleSelect(rule._id)}
                name={rule._id}
              />
            }
            label={rule.description}
            key={rule._id}
          />
        ))
      ) : (
        <div>هیچ دسترسی ای برای این نقش هنوز تعریف نشده است.</div>
      )}
    </div>
  );
};

export default ListRules;
